import { FILTER_MISMATCH_REASONS } from 'utils/filter-mismatch';

const NON_REASON_TAGS = new Set<string>([
  'Custom',
  'Filter Mismatch',
  'Recommended'
]);

// Mismatch reasons ride in tags after 'Filter Mismatch'; they must not show
// under "Why we recommend this system" with green checkmarks.
export const isRecommendationReason = (tag: string): boolean =>
  !NON_REASON_TAGS.has(tag) && !FILTER_MISMATCH_REASONS.has(tag);
